var map = {
	"./bg-BG.json": "d6b3",
	"./cs-CZ.json": "de67",
	"./da-DK.json": "7107",
	"./de-DE.json": "3f18",
	"./el-GR.json": "d75d",
	"./en-EN.json": "bf83",
	"./es-ES.json": "f2f1",
	"./et-EE.json": "ef8e",
	"./fi-FI.json": "43c2",
	"./fr-FR.json": "ff10",
	"./hu-HU.json": "76b3",
	"./id-ID.json": "cca3",
	"./it-IT.json": "b97c",
	"./ja-JP.json": "a3e2",
	"./lt-LT.json": "a550",
	"./lv-LV.json": "6274",
	"./nl-NL.json": "53b1",
	"./pl-PL.json": "13e5",
	"./pt-PT.json": "ce3b",
	"./ro-RO.json": "5b1e",
	"./ru-RU.json": "a158",
	"./sk-SK.json": "746f",
	"./sl-SI.json": "d505",
	"./sv-SE.json": "c66d",
	"./tr-TR.json": "da06",
	"./uk-UA.json": "d8d0",
	"./zh-CN.json": "6366"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "45f6";